import React, { useEffect, useRef, useState, useContext } from "react";

import { Button } from "primereact/button";
import { Toast } from "primereact/toast";

import Card from "../../../Components/Card/Card";
import { getLabel } from "../../../Services/Language/LanguageService";
import { baseLang } from "../../../Lang/BaseLang";
import { ConfigContext } from "../../../Context/ConfigContext/ConfigContext";
import { AuthContext } from "../../../Context/AuthContext/AuthContext";
import AgGrid from "../../../Components/Tables/AgGrid/AgGrid";
import { setTitlePage } from "../../../Services/Config/ConfigService";

import { getInformacionEmpresa } from "../../../API/Global/InformacionEmpresa/InformacionEmpresaRequest";
import InformacionEmpresaCRUD from "./InformacionEmpresaCRUD";


const InformacionEmpresaScreen = () => {
  const toast = useRef(null);
  const { config } = useContext(ConfigContext);
  const { userAuth } = useContext(AuthContext);

  const [loading, setLoading] = useState(false);
  const [infEmpresa, setInfEmpresa] = useState([]);
  const [selected, setSelected] = useState([]);
  const [showDialog, setShowDialog] = useState(false);

  const getInfo = async () => {
    setLoading(true);
    const inf = await getInformacionEmpresa();
    setInfEmpresa(inf);
    setLoading(false);
  };

  const columns = [
    {
      field: "IdEmpresa",
      header: "ID",
      headerEn: "ID",
      hidden: userAuth.IdRol === 1,
      className: "XXsmall",
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "NombreLegal",
      header: "Nombre Legal",
      headerEn: "Legal Name",
      className: "Xlarge",
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "NombreCorto",
      header: "Nombre Corto",
      headerEn: "Short Name",
      className: "medium",
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "RTN",
      header: "RTN",
      headerEn: "RTN",
      className: "medium",
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "Telefono",
      header: "Teléfono",
      headerEn: "Telefono",
      className: "medium",
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "Direccion",
      header: "Dirección",
      headerEn: "Address",
      className: "XXlarge",
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "CorreoInformativo",
      header: "Correo",
      headerEn: "Email",
      className: "large",
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "CorreoVentas",
      header: "Correo Ventas",
      headerEn: "Email",
      className: "large",
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "CorreoCompras",
      header: "Correo Compras",
      headerEn: "Email",
      className: "large",
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "LogoPrimario",
      header: "Logo Primario",
      headerEn: "",
      className: "Xlarge",
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "LogoPrimarioDark",
      header: "Logo Primario Sobre Oscuro",
      headerEn: "",
      className: "Xlarge",
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "LogoPrimarioVertical",
      header: "Logo Primario Verical",
      headerEn: "",
      className: "Xlarge",
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "LogoPrimarioVerticalDark",
      header: "Logo Primario Verical Sobre Oscuro",
      headerEn: "",
      className: "Xlarge",
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "LogoPrimarioB64",
      header: "Logo Primario B64 Sobre Claro",
      headerEn: "",
      className: "Xlarge",
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "LogoPrimarioDarkB64",
      header: "Logo Primario B64 Sobre Oscuro",
      headerEn: "",
      className: "Xlarge",
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "IdEmpresa",
      className: "colum-width-small",
      header: "",
      Format: "Botones",
      filter: false,
      frozen:true,
      alignFrozen: "right",
      Botones: [
        {
          icon: "pi pi-pencil",
          tooltip: "Editar",
          onClick: (rowData) => {
            setShowDialog(true);
            setSelected(rowData);
          },
          tooltipOptions: {
            position: "right",
          },
        },
      ],
    },
  ];

  const table = {
    Columns: columns,
    Data: infEmpresa,
    loading: loading,
  };

  useEffect(() => {
    setTitlePage(getLabel(baseLang, "informacionEmpresa", config.language));
    getInfo();
    
  }, []);
  

  return (
    <div
      className=" p-fluid px-4"
      style={{ width: "100%", height: "100%", margin: "auto" }}
    >
      <Toast ref={toast} />
      <Card
        titulo={
          <div className="botones">
            <h3>{getLabel(baseLang, "informacionEmpresa", config.language)}</h3>
            <Button icon="pi pi-refresh" onClick={getInfo} />
          </div>
        }
        contenido={
          <div className="p-4" style={{ height: "90vh" }}>
            <AgGrid table={table} />
          </div>
        }
      />

      {showDialog && (
        <InformacionEmpresaCRUD
          toastRef={toast}
          showDialog={showDialog}
          selected={selected}
          setShowDialog={setShowDialog}
          getInfo={getInfo}
        />
      )}
    </div>
  );
};

export default InformacionEmpresaScreen;
